module.exports = __webpack_public_path__ + "media/images/front/responsive/clinic_top_page/338629/target03-f2b8de5601cf09b31d6b9e51e3f89263.png";